import { Box, Card, CardActionArea, CardActions, CardContent, CardMedia, Paper, Collapse, IconButton, Divider } from '@mui/material';
import { makeStyles } from "@mui/styles";

import React, { useState } from 'react';
import { Dialpad, ExpandLess, ExpandMore } from '@mui/icons-material'

const useStyles = makeStyles((theme) => {

    const desktop = theme.breakpoints.up("lg");
    const mobile = theme.breakpoints.down("md");

    const obj = {
        root: {
            display: 'flex',
            [mobile]: {
                flexDirection: 'column'
            },
            [desktop]: {
                flexDirection: 'row',
                //height: 150
            },
        },
        content: {
            flex: '1',            
            // [desktop]: {
            //     height: 150,                
            // }
        },
        mainContent: {
            [desktop]: {
                height: 150,                
            }
        },
        cover: {
            [desktop]: {
                width: 150,
                height: 150
            },
            [mobile]: {
                margin: "0 auto",
                marginTop: theme.spacing() 
            }
        },
        actions: {
            [desktop]: {
                width: 150,
                //height: 150,
            },            
            [mobile]: {       
                margin: "0 auto"
                
            }
        },
        mobileimg: {
            [mobile]: {       
                width: 150,
                height: 150,
                
            }
        },
        centered: {
            textAlign: 'center'
        }
    }

    return obj;
})


const Lista = () => {

    const classes = useStyles();   
    const [expanded, setExpanded] = useState({}) 

    const dati = [
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {},        
    ]

    return (
        <>
            {dati.map((dato, indiceDato) => {

                const currentExpanded = expanded?.[indiceDato] ?? false;

                return (
                    <Box my={2} key={indiceDato}>
                        <Card elevation={2}>
                            <div className={classes.root}>
                                <CardMedia className={classes.cover} classes={{
                                    img: classes.mobileimg
                                }} component="img" src={"https://via.placeholder.com/150"} />                                   
                                
                                <CardContent className={[classes.content, classes.mainContent].join(" ")}>
                                    <Box p={3}>
                                        testo normale
                                    </Box>
                                </CardContent>
                                
                                <CardActionArea className={classes.actions}>
                                    <CardActions classes={{
                                        root: classes.mobileactions
                                    }}>
                                        Acquista
                                    </CardActions>
                                </CardActionArea>
                                
                            </div>
                            <Divider color="primary"  />
                            <div className={classes.additionalData}>
                                <CardActionArea>
                                    <CardActions onClick={e => setExpanded({[indiceDato]: !currentExpanded })} className={classes.root}>
                                        <div className={classes.content}>
                                            Servizi Aggiuntivi
                                        </div>
                                        
                                        <IconButton  size="small" color="primary">
                                            {currentExpanded ? <ExpandLess /> : <ExpandMore />}
                                        </IconButton>
                                    </CardActions>
                                </CardActionArea>
                                <Collapse in={currentExpanded} timeout="auto" unmountOnExit>                                
                                    <CardContent>
                                        <Box p={3}>
                                            <pre>{JSON.stringify(dato, null, 2)}</pre>
                                        </Box>
                                    </CardContent>
                                    <CardActionArea>
                                        <CardActions onClick={e => "niente"} >
                                            <div className={[classes.content, classes.centered].join(" ")}>
                                                Ricalcola Tariffa
                                                <IconButton  size="small" color="primary">
                                                    <Dialpad />
                                                </IconButton>
                                            </div>
                                            
                                            
                                        </CardActions>
                                    </CardActionArea>
                                </Collapse>
                            </div>

                        </Card>
                    </Box>
                    
                )
            })}
        </>
    )
    

}

export default Lista;